import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TaskListTemplate } from '@/templates/BossBaby';
import { useBossBabyTasks } from '@/hooks/useBossBaby';
import { useSnackbar } from 'notistack';

export const TaskList: React.FC = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  
  const {
    tasks,
    loading,
    total,
    page,
    limit,
    fetchTasks,
    deleteTask,
    handlePageChange,
    handleRowsPerPageChange,
  } = useBossBabyTasks();

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  const handleSearch = (params: object) => {
    fetchTasks(params);
  };

  const handleEdit = (taskId: number) => {
    navigate(`/boss-baby/tasks/${taskId}/edit`);
  };

  const handleDelete = async (taskId: number) => {
    if (window.confirm('Are you sure you want to delete this task?')) {
      try {
        await deleteTask(taskId);
        enqueueSnackbar('Task deleted successfully', { variant: 'success' });
      } catch (error) {
        console.error('Delete error:', error);
      }
    }
  };

  const handleCreate = () => {
    navigate('/boss-baby/tasks/create');
  };

  return (
    <TaskListTemplate
      tasks={tasks}
      loading={loading}
      total={total}
      page={page}
      limit={limit}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      onSearch={handleSearch}
      onEdit={handleEdit}
      onDelete={handleDelete}
      onCreate={handleCreate}
    />
  );
};